module.exports = __webpack_public_path__ + "assets/images/limited_activity_g.2bb2d032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/limited_activity_g.png
// module id = 752
// module chunks = 1